module.exports = __webpack_public_path__ + "img/home-page-hero-banner.a9bb7372.jpg";